import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { ChevronLeftIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Container, Spinner, Toolbar } from '@treams/treams-ui';

import TalentReviewV1 from './TalentReviewV1';

export default function TalentReview(props: { id: string }) {
	const { t } = useTranslation();

	const query = graphql.useTalentReviewQuery({ variables: { id: props.id } });

	return (
		<Container>
			{query.data ? (
				<Box py={4}>
					<Toolbar>
						<Button
							icon={<ChevronLeftIcon />}
							link="/talent-reviews"
							title={t('goals.show.toolbar.back')}
							type="secondary"
						/>
					</Toolbar>
					<TalentReviewV1 review={query.data.talentReview as graphql.TalentReview} />
				</Box>
			) : (
				<Flex my={5} justifyContent="center">
					<Spinner />
				</Flex>
			)}
		</Container>
	);
}
